<template>
  <div class="container">
    <!-- logo、关于我们、联系我们 -->
    <Nav></Nav>
    <!-- 背景不动的星星 -->
    <Stars></Stars>
    <!-- 背景移动的云 -->
    <Cloud></Cloud>
    <!-- 跟随鼠标移动的建筑 -->
    <Build></Build>
    <!-- 背景商店 有hover效果的 -->
    <Store></Store>
    <!-- 版权信息 -->
    <CopyInfo></CopyInfo>
    <!-- 关于我们 -->
    <AboutUs></AboutUs>
    <!-- 联系我们 -->
    <ContactUs></ContactUs>
  </div>
</template>

<script>
import Nav from "./Nav";
import Stars from "./Stars";
import Cloud from "./Cloud";
import Build from "./Build";
import Store from "./Store";
import CopyInfo from "./CopyInfo";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
export default {
  name: "Container",
  components: {
    Nav,
    Stars,
    Cloud,
    Build,
    Store,
    CopyInfo,
    AboutUs,
    ContactUs
  }
};
</script>

<style scoped>
.container {
  width: 80%;
  height: 100%;
  background-color: #161f2b;
  background-image: url("../assets/images/in/0706-不闪星星-07.png");
  background-repeat: no-repeat;
  background-position: top;
  background-size: contain;
  overflow: hidden;
  min-width: 1080px;
  min-height: 100vh;
  position: relative;
}
</style>
